import { TableColumnType } from 'src/types/table';

export const REQUIRED_WEBHOOK_DELIVERIES_GRID_COLUMNS = ['EVENT_ID', 'SENDING_TIME', 'STATUS_CODE'];

export const groupedColumns: TableColumnType[] = [
    {
        key: 'SENDING_TIME',
        label: 'sendingTime',
        type: 'dateTime',
        defaultShow: true,
    },
    {
        key: 'EVENT_ID',
        label: 'eventId',
        defaultShow: true,
        tooltip: 'webhookRecords.table.eventIdTooltip',
        customRender: true,
    },
    {
        key: 'WEBHOOK_TYPE',
        label: 'webhookType',
        type: 'select',
        selectOption: 'webhookTypeCodes',
        defaultShow: true,
    },
    {
        key: 'METHOD',
        label: 'method',
        type: 'select',
        selectOption: 'webhookMethodCodes',
        defaultShow: true,
    },
    {
        key: 'URL',
        label: 'url',
        defaultShow: true,
        customStyle: { maxWidth: '220px' },
        customStyleHeader: { maxWidth: '220px' },
    },
    {
        key: 'ATTEMPT_COUNT',
        label: 'attemptCount',
        type: 'number',
        defaultShow: true,
        customRender: true,
    },
    {
        key: 'STATUS_CODE',
        label: 'statusCode',
        type: 'number',
        defaultShow: true,
        customRender: true,
    },
    {
        key: 'RETRY_RELATION',
        label: 'retryRelation',
        defaultShow: true,
        customRender: true,
    },
    {
        key: 'RESPONSE_MESSAGE',
        label: 'responseMessage',
        defaultShow: true,
        customRender: true,
    },
    {
        key: 'PAYLOAD',
        label: 'payload',
        defaultShow: true,
        customRender: true,
    },
    {
        key: 'WEBHOOK_ID',
        label: 'webhookId',
        type: 'number',
        defaultShow: false,
    },
];

export const attemptsColumns: TableColumnType[] = [
    {
        key: 'SENDING_TIME',
        label: 'sendingTime',
        type: 'dateTime',
        defaultShow: true,
    },
    {
        key: 'EVENT_ID',
        label: 'eventId',
        defaultShow: true,
        tooltip: 'webhookRecords.table.eventIdTooltip',
        customRender: true,
    },
    {
        key: 'ATTEMPT',
        label: 'attempt',
        type: 'number',
        defaultShow: true,
    },
    {
        key: 'WEBHOOK_TYPE',
        label: 'webhookType',
        type: 'select',
        selectOption: 'webhookTypeCodes',
        defaultShow: true,
    },
    {
        key: 'METHOD',
        label: 'method',
        type: 'select',
        selectOption: 'webhookMethodCodes',
        defaultShow: true,
    },
    {
        key: 'URL',
        label: 'url',
        defaultShow: true,
        customStyle: { maxWidth: '220px' },
        customStyleHeader: { maxWidth: '220px' },
    },
    {
        key: 'STATUS_CODE',
        label: 'statusCode',
        type: 'number',
        defaultShow: true,
        customRender: true,
    },
    {
        key: 'RETRY_RELATION',
        label: 'retryRelation',
        defaultShow: true,
        customRender: true,
    },
    {
        key: 'RESPONSE_MESSAGE',
        label: 'responseMessage',
        defaultShow: true,
        customRender: true,
    },
    {
        key: 'PAYLOAD',
        label: 'payload',
        defaultShow: true,
        customRender: true,
    },
    {
        key: 'WEBHOOK_ID',
        label: 'webhookId',
        type: 'number',
        defaultShow: false,
    },
];
